import type { FaireProductEntity } from "../../entity_types/product";

export const p_nkxybu7tb5: FaireProductEntity = {
  token: "p_nkxybu7tb5",
  type: "product",
  name: "Friendo Blendo Espresso",
  brandToken: "b_cgzjcth7hb",
  brandName: "Four Barrel Coffee",
  imageUrl: "https://cdn.faire.com/fastly/7e7885a324713899cb29230e83dd3f261566fe8dc23f870765968693db0fa2de.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d9b77d189866e2e3d666defff1e6e34665dc1c664621e6d419362ca6753b9d17.jpeg",
    "https://cdn.faire.com/fastly/c8fd0d2a7d88aea5a87c7feb2c41a95c9006b47267a48c5aad688ee237aa4bd8.webp"
  ],
  priceDollars: 26,
  description: "Citrus flavors swan dive into fresh berry full forward fold, which jumps or walks back into down dog, then ascends into a toffee sweetness sun salutation. Swan dive.\n\nFriendo Blendo Espresso is our number best seller — served all over the world.\n\nWhen using our espresso, we like 1 part espresso to 1.5 part liquid yield. And while it's tastiest 7-10 days off roast, we figure you're so good at this you could probably make it work any day.\n\n• Dose: 18.5-20.5g\n• Yield: 27-31g\n• Time: 26-31s",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:06.682Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
